import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/classCountSagas";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";

export const Dropdown = ({ title, slice: key }) => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.classCount.filters[key]);
  const selectedOptions = useSelector((state) => state.classCount.selectedFilters[key]);

  const pendingFilters = useSelector((state) => state.classCount.pendingFilters);
  const isLoading = pendingFilters.includes(key);

  const onOptionsChange = (data) => {
    dispatch(actionCreators.updateFilters({ data, key }));
  };

  return (
    <div className="select-box-no-width">
      <p>{title}</p>
      {isLoading ? (
        <button className="picky__input">
          <LoadingAnimation uiLoader />
        </button>
      ) : (
        <MultiSelectDropdown
          placeholder="Not Available"
          options={options}
          selectedFilters={selectedOptions}
          numberDisplayed={0}
          includeFilter
          enableOnly
          includeSelectAll
          onSelectChange={onOptionsChange}
        />
      )}
    </div>
  );
};
